module.exports = {
  messages: {
    CN: {
      "activity.info": "活动信息",
      "activity.infoprop": "请输入活动名称/编号",
      "activity.type": "活动类型",
      "activity.typeprop": "请选择活动类型",
      "activity.selecttype": "选择活动类型",
      "activity.repeattimes": "重复参与次数",
      "activity.time": "活动时间",
      "activity.name": "活动名称",
      "activity.nameprop": "请输入活动名称",
      "activity.offlinesure": "你确定要下线该活动吗？",
      "activity.sureonline": "你确定要上线该活动吗？",
      "activity.deletesure": "你确定要删除该活动吗？",
      "activity.copysure": "你确定要复制该活动吗？",
      "activity.buttonoffline": "下线",
      "activity.goonline": "上线",
      "activity.goonlinesuccess": "上线成功",
      "activity.doublepoints": "单品积分翻倍",
      "activity.unitdiscount": "单品打折",
      "activity.specialoffer": "单品特价",
      "activity.fullreduction": "满减",
      "activity.fulldiscount": "满折",
      "activity.fullpackage": "满包邮",
      "activity.notonline": "未上线",
      "activity.notstarted": "未开始",
      "activity.attheevent": "活动中",
      "activity.itisover": "已结束",
      "activity.offline": "已下线",
      "activity.selectactivitytime": "请选择活动时间",
      "activity.zoneofaction": "活动区域",
      "activity.zoneofactionprop": "请选择活动区域",
      "activity.disablepay": "禁用支付方式",
      "activity.activityicon": "活动Icon",
      "activity.promotionlink": "活动描述链接",
      "activity.promotionlinkprop": "请输入活动描述链接",
      "activity.copy": "复制",
      "activity.repeattimesprop": "请输入重复参与次数",
      "activity.discountsettings": "折扣设置",
      "activity.discountprop": "请输入折扣",
      "activity.discount": "折",
      "activity.integralmultiple": "积分倍数",
      "activity.activityintegral": "活动积分倍数",
      "activity.originalintegral": "商品原积分倍数",
      "activity.multipleprop": "请输入积分倍数",
      "activity.multiple": "倍",
      "activity.rule": "规则",
      "activity.stepfullreduction": "阶梯满减",
      "activity.everyfullminus": "每满减",
      "activity.addrule": "新增规则",
      "activity.full": "满",
      "activity.reduce": "减",
      "activity.quantityofgoods": "单品参与件数",
      "activity.quantityofgoodsprop": "请输入单品参与件数",
      "activity.totalgoods": "商品总价",
      "activity.totalgoodsprop": "请输入商品总价",
      "activity.fulldiscounttwo": "满额折",
      "activity.fullpackagediscount": "满件折",
      "activity.contentone": "根据你的选择有",
      "activity.contenttwo": "种商品适用该发货渠道活动规则。",
      "activity.eachfullamount": "每满",
      "activity.rulesandconditions": "请输入活动规则条件",
      "activity.enjoy": "享",
      "activity.productandcustomer": "配置商品",
      "activity.dyxcustomer": "配置得意先",
      "activity.essentialInformation": "基本信息",
      "activity.commodityrange": "商品范围",
      "activity.firstlineprompt": "1.第一列必须是商品编号",
      "activity.secondlineprompt": "2.从第二行数据开始导入",
      "activity.off": "OFF(%)",
      "activity.offtwo": "%OFF",
      "activity.numberofparticipants": "参与件数",
      "activity.inventoryquantity": "库存数量",
      "activity.remind": "提醒：时间有重叠的特价活动或者折扣活动，活动上线时活动价格会覆盖旧活动价格",
      "activity.setdiscount": "设置折扣",
      "activity.setnumber": "设置参与件数",
      "activity.limitfirstprop": "每人每次下单，前",
      "activity.limitsecondtprop": "件享受折扣，超出后可原价购买",
      "activity.limitprop": "请是输入限购设置",
      "activity.cancelinvalidation": "取消失效",
      "activity.propnumber": "请输入参与件数",
      'activity.batchoff': '批量设置折扣',
      'activity.batchintegral': '批量设置积分倍数',
      'activity.setspecialoffer': '设置特价',
      'activity.batchspecialoffer': '批量设置特价',
      'activity.setintegral': '设置积分倍数',
      'activity.isnull': '商品信息不完整，请完善后重试！',
      'activity.firsttip': '必须是文章链接，否则链接将无效！',
      'activity.tips': '温馨提示',
      'activity.tipsContent': '如果指定不参加商品列表为空，即为全部商品参加',
      'activity.tipsContent2': '如果指定得意先参加列表为空，即为全部得意先参加',
      'activity.activityLocation': '活动地址',
      'activity.dscp': '活动描述',
      'activity.warning': '请先为活动添加商品!',
      'account.dyxNumber': '得意先编号',
      'account.dyxName': '得意先名称',
      'account.status': '得意先状态',
      'account.yetai': '业态',
      'account.ddz': '担当者',
      'emailAction': '操作',
      'activity.selectDyx': '勾选得意先'
    },
    JP: {
      "activity.info": "キャンペーン情報",
      "activity.infoprop": "キャンペーン名/番号を入力してください",
      "activity.type": "活动类型",
      "activity.typeprop": "请选择活动类型",
      "activity.selecttype": "选择活动类型",
      "activity.repeattimes": "重复参与次数",
      "activity.time": "キャンペーン期間",
      "activity.name": "キャンペーン名",
      "activity.nameprop": "キャンペーン名を入力してください",
      "activity.offlinesure": "このキャンペーンを無効しますか？",
      "activity.sureonline": "このキャンペーンを有効しますか？",
      "activity.deletesure": "このキャンペーンを削除してもよろしいですか？",
      "activity.copysure": "このアクティビティをコピーしてもよろしいですか？",
      "activity.buttonoffline": "無効にする",
      "activity.goonline": "有効にする",
      "activity.goonlinesuccess": "有効にしました",
      "activity.doublepoints": "单品积分翻倍",
      "activity.unitdiscount": "单品打折",
      "activity.specialoffer": "单品特价",
      "activity.fullreduction": "满减",
      "activity.fulldiscount": "满折",
      "activity.fullpackage": "满包邮",
      "activity.notonline": "無効",
      "activity.notstarted": "有効/未開始",
      "activity.attheevent": "有効/キャンペーン中",
      "activity.itisover": "有効/終了",
      "activity.offline": "已下线",
      "activity.selectactivitytime": "キャンペーン時間を選択してください",
      "activity.zoneofaction": "活动区域",
      "activity.zoneofactionprop": "请选择活动区域",
      "activity.disablepay": "禁用支付方式",
      "activity.activityicon": "活动Icon",
      "activity.promotionlink": "活动描述链接",
      "activity.promotionlinkprop": "请输入活动描述链接",
      "activity.copy": "コピー",
      "activity.repeattimesprop": "请输入重复参与次数",
      "activity.discountsettings": "折扣设置",
      "activity.discountprop": "请输入折扣",
      "activity.discount": "折",
      "activity.integralmultiple": "积分倍数",
      "activity.activityintegral": "活动积分倍数",
      "activity.originalintegral": "商品原积分倍数",
      "activity.multipleprop": "请输入积分倍数",
      "activity.multiple": "倍",
      "activity.rule": "规则",
      "activity.stepfullreduction": "阶梯满减",
      "activity.everyfullminus": "每满减",
      "activity.addrule": "新增规则",
      "activity.full": "满",
      "activity.reduce": "减",
      "activity.quantityofgoods": "单品参与件数",
      "activity.quantityofgoodsprop": "请输入单品参与件数",
      "activity.totalgoods": "商品总价",
      "activity.totalgoodsprop": "请输入商品总价",
      "activity.fulldiscounttwo": "满额折",
      "activity.fullpackagediscount": "满件折",
      "activity.contentone": "根据你的选择有",
      "activity.contenttwo": "种商品适用该发货渠道活动规则。",
      "activity.eachfullamount": "每满",
      "activity.rulesandconditions": "请输入活动规则条件",
      "activity.enjoy": "享",
      "activity.productandcustomer": "商品指定",
      "activity.dyxcustomer": "得意先指定",
      "activity.essentialInformation": "基本情報",
      "activity.commodityrange": "商品範囲",
      "activity.firstlineprompt": "1.第一列必须是商品编号",
      "activity.secondlineprompt": "2.从第二行数据开始导入",
      "activity.off": "OFF(%)",
      "activity.offtwo": "%OFF",
      "activity.numberofparticipants": "参与件数",
      "activity.inventoryquantity": "在庫数",
      "activity.remind": "提醒：时间有重叠的特价活动或者折扣活动，活动上线时活动价格会覆盖旧活动价格",
      "activity.setdiscount": "设置折扣",
      "activity.setnumber": "设置参与件数",
      "activity.limitfirstprop": "每人每次下单，前",
      "activity.limitsecondtprop": "件享受折扣，超出后可原价购买",
      "activity.limitprop": "请是输入限购设置",
      "activity.cancelinvalidation": "取消失效",
      "activity.propnumber": "请输入参与件数",
      'activity.batchoff': '批量设置折扣',
      'activity.batchintegral': '批量设置积分倍数',
      'activity.setspecialoffer': '设置特价',
      'activity.batchspecialoffer': '批量设置特价',
      'activity.setintegral': '设置积分倍数',
      'activity.isnull': '商品信息不完整，请完善后重试！',
      'activity.firsttip': '必须是文章链接，否则链接将无效！',
      'activity.tips': 'ヒント',
      'activity.tipsContent': '指定された商品がない場合は、全ての商品が参加します',
      'activity.tipsContent2': '指定された得意先がない場合は、全ての得意先が参加します',
      'activity.activityLocation': '活动地址',
      'activity.dscp': 'キャンペーン説明',
      'activity.warning': 'まず、キャンペーンに商品を追加してください!',
      'account.dyxNumber': '得意先コード',
      'account.dyxName': '得意先名',
      'account.status': '得意先状態',
      'account.yetai': '業態',
      'account.ddz': '担当者',
      'emailAction': '操作',
      'activity.selectDyx': '得意先を選択'
    }
  }
};